import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css']
})
export class MemberComponent implements OnInit {

  project;
  profile;
  rooms   = []; 
  showRoomSetting;
  constructor(public cm:CommonService) {
    this.cm.getMessage().subscribe((massage)=>{
      if(massage.command == 'menu2'){
        this.clickMenu();
      }
    })

  }

  ngOnInit() {
    this.profile = this.cm.getProfile();
    this.project = this.cm.getProject();
    this.rooms   = this.cm.getRoom();
    this.getMemberFromFirebase();
  }

  isShowMenu = true;
  clickMenu(){
    this.isShowMenu = !this.isShowMenu;
    this.cm.sendMessage('menu',String(this.isShowMenu));
  }

  members = [];
  getMemberFromFirebase(){
    this.cm.db.collection('members',ref => ref.where("project_uid","==",this.project.uid)).get().toPromise().then((data)=>{
      this.members = [];
      for(var i = 0;i < data.docs.length;i++){
        var member_data = data.docs[i].data();
        member_data.room = this.getRoomDataFromMember(member_data.uid);
        this.members.push(member_data);
        this.data_show = this.members;
      }
      
    });
  }

  getRoomDataFromMember(uid){
      var data;
      for(var i = 0;i <this.rooms.length;i++){
        for(var j = 0;j < this.rooms[i].members.length;j++){
          if(uid == this.rooms[i].members[j]){
            data = {
              room_name:this.rooms[i].room_name,
              building_name:this.rooms[i].building_name,
              zone:this.rooms[i].zone,
              floor:this.rooms[i].floor
            }
            return data;
          }
        }
      }
  }

  @ViewChild("input_search_text") inputEl: ElementRef;
  data_show;
  search(text){
    this.data_show = [];
    for(var i = 0;i<this.members.length;i++){
      var sameData = 0;
      for (var key in this.members[i]) {
        if(String(this.members[i][key]).match(text)){
            this.data_show.push(this.members[i]);
            sameData = 1;
        }

        for (var key in this.members[i].attribute) {
          if(String(this.members[i].attribute[key]).match(text) && sameData == 0){
              this.data_show.push(this.members[i]);
          }
        } 
        sameData = 0;
      } 
    }
    this.data_show = this.cm.removeDuplicates(this.data_show,'uid');
  }

}
